/**
 * Package: YTAHA\IntelliBuilder
 *
 */

const Divider = () => {
	return (
		<div className="intelli-builder-schedule-divider"></div>
	);
};

export default Divider;
